import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { RightsEnum } from '../enums/rights.enum';
import { LocalStorageService } from './local-storage.service';
import { IAuth } from '../models/auth.model';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class UserPermissionsService {

    private user: IAuth = {
        firstName: "",
        lastName: "",
        username: "",
        email: "",
        roles:[]   // Initialize roles as an empty array to match IAuth interface.
    };
    private authSub!: Observable<{} | Response>;
    private userPermissions!: { [id: number]: RightsEnum[] };
    private permsLoaded = false;

   
//    private msalService!: MsalService;

    constructor(private _http: HttpClient, private _storage: LocalStorageService, private _router: Router) {
        
        //Load the user permissions from storage
        let perms = this._storage.get('user-perms');


        //If we have user permissions load them in
       if (perms != null ) {
            this.userPermissions = perms; // JSON.parse(perms);
            this.permsLoaded = true;
        }
   

        //this.CallAuth();
    }   

    // public CallAuth() {
    //     //Call auth and get our latest permissions
    //     this.authSub = this._http.get("productfamily", { observe: 'response'});
    //     this.authSub.subscribe({
    //         next: (res: any) => {
    //             if(res.headers !== undefined) {
    //                this.setUserPermissions(JSON.parse(res.headers.get('AUTH_RIGHTS') ?? '{}'));
    //                this.setUserInfo(JSON.parse(res.headers.get('USER_INFO')));
    //             }
    //             else {
    //                 this._router.navigate(['error/offline']);
    //             }
    //         },
    //         error: (error: any) => {this.handleError(error)},
    //         complete: () => this.permsLoaded = true
    //     }
    //     );
    // }

    //There was an error while calling the auth api
    
    private handleError(error: Response | any) {
        if (error.status === 0 || error.staus === 404) {
            this._router.navigate(['error/offline']);
        } else if(error.status >= 500) {
            this._router.navigate(['error/500']);
        }

        return throwError(() => error);
    }

    //Updates the users permissions and sets them in storage
    public setUserPermissions(perms: { [id: number]: RightsEnum[] }) {
        this._storage.set('user-perms', perms);
        this.userPermissions = perms;
        this.permsLoaded = true
    }

    public setUserInfo(userInfo: IAuth) {
        this._storage.set('user-info', userInfo);
        this.user = userInfo;
    }

    //returns the users permissions
    public getUserPermissions(): { [id: number]: RightsEnum[] } {
        return this.userPermissions;
    }

    //Returns true if the auth call has finished, false otherwise
    public havePermsLoaded(): boolean {
        return this.permsLoaded;
    }

    //Returns the users full name
    public getUserName(): string {
        return `${this.user.firstName} ${this.user.lastName}`;
    }

    public getUser511(): string {
        return this.user.username;
    }

    //Returns the observable for the auth call
    //Should only be used if the auth call hasn't finished yet
    public getAuthSub(): Observable<{} | Response> {
        return this.authSub;
    }

}